import * as Sentry from "@sentry/react";
import { ENVIRONMENT } from "@config/app";
import { SENTRY_DSN } from "@config/sentry";
import { isStorePanelLocation } from "@utils/storePanelLocation";

if (SENTRY_DSN && !isStorePanelLocation()) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    enabled: ENVIRONMENT !== "local",
    attachStacktrace: false,
    dataCollection: {
      userInfo: false,
      httpBodies: [],
    },
  });
}
